var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReason6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.121 6.151L17.849 0.878C17.282 0.312 16.528 0 15.728 0H8.272C7.471 0 6.718 0.312 6.151 0.879L0.879 6.151C0.312 6.718 0 7.471 0 8.272V15.728C0 16.529 0.312 17.282 0.879 17.849L6.151 23.121C6.718 23.688 7.471 24 8.272 24H15.728C16.528 24 17.282 23.688 17.85 23.121L23.121 17.849C23.687 17.282 24 16.529 24 15.728V8.272C24 7.471 23.687 6.718 23.121 6.151ZM22 15.728C22 15.991 21.894 16.249 21.707 16.435L16.436 21.706C16.246 21.895 15.994 22 15.727 22H8.271C8.008 22 7.75 21.893 7.564 21.707L2.292 16.435C2.106 16.248 1.999 15.991 1.999 15.728V8.272C1.999 8.009 2.106 7.751 2.292 7.565L7.565 2.293C7.752 2.107 8.009 2 8.272 2H15.728C15.995 2 16.247 2.104 16.436 2.293L21.707 7.565C21.894 7.752 22 8.009 22 8.272V15.728ZM16.439 8.975L13.396 12.018L16.439 15.061L15.025 16.475L11.982 13.432L8.939 16.475L7.525 15.061L10.568 12.018L7.525 8.975L8.939 7.561L11.982 10.604L15.025 7.561L16.439 8.975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason6);
export default __webpack_public_path__ + "static/media/reason6.c9f5a095e37e84bc37204b2785404cdc.svg";
export { ForwardRef as ReactComponent };